import { render, staticRenderFns } from "./Cobrador.vue?vue&type=template&id=bf592b9e&lang=pug&"
import script from "./Cobrador.vue?vue&type=script&lang=js&"
export * from "./Cobrador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports